import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { GeneralService } from '../../shared/services/general.service';
import { DiagnosticoIpResponse, VpnResponse } from '../models/vpn.model';

@Injectable({
  providedIn: 'root',
})
export class VpnService {
  public URL_API = environment.apiURLNew;

  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public getDiagnosticoIp(): Observable<string> {
    return this.http.get<DiagnosticoIpResponse>(`${this.URL_API}/api/diagnostico/ip`).pipe(
      take(1),
      map((res) => res?.ipDetectada ?? ''),
      catchError(() => of('')),
    );
  }

  public getVpn(ip: string): Observable<VpnResponse | null> {
    if (!ip) {
      return of(null);
    }
    const params = this.generalService.buildParams({ ip });
    return this.http.get<VpnResponse>(`${this.URL_API}/api/vpn`, { params }).pipe(
      take(1),
      catchError(() => of(null)),
    );
  }
}
